import { useState } from "react";
import { Download, ChevronDown, ChevronRight } from "lucide-react";

const COLUMNS = [
  { name: "origin_pincode",       required: true,  format: "6 digits",       example: "530001" },
  { name: "dest_pincode",         required: true,  format: "6 digits",       example: "500001" },
  { name: "weight_kg",            required: true,  format: "number",         example: "25.5" },
  { name: "product_category",     required: true,  format: "code",           example: "APPAREL" },
  { name: "service_type",         required: true,  format: "text",           example: "STANDARD" },
  { name: "declared_value",       required: false, format: "number",         example: "5000" },
  { name: "insurance_opted",      required: false, format: "YES/NO",         example: "YES" },
  { name: "receiver_name",        required: true,  format: "text",           example: "John Doe" },
  { name: "receiver_phone",       required: true,  format: "10 digits",      example: "9876543210" },
  { name: "receiver_address",     required: true,  format: "text",           example: "123 Main St" },
  { name: "receiver_city",        required: true,  format: "text",           example: "Hyderabad" },
  { name: "num_boxes",            required: false, format: "number",         example: "1" },
  { name: "customer_reference",   required: false, format: "text",           example: "PO-2026-001" },
  { name: "special_instructions", required: false, format: "text",           example: "Fragile" },
];

export default function CsvFormatReferenceCard({ onDownloadTemplate }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="bg-white border border-slate-200 rounded-xl" data-testid="csv-format-ref-card">
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between px-4 py-3 text-left"
        data-testid="csv-format-ref-toggle"
      >
        <div className="flex items-center gap-2">
          {open ? <ChevronDown className="w-4 h-4 text-slate-400" /> : <ChevronRight className="w-4 h-4 text-slate-400" />}
          <span className="text-sm font-bold text-slate-700 uppercase">CSV Format Reference</span>
        </div>
        <span className="text-xs text-teal-600 font-semibold">{open ? "Hide format" : "View format"}</span>
      </button>
      {open && (
        <div className="border-t border-slate-100 p-4 space-y-3">
          <div className="overflow-x-auto">
            <table className="w-full text-xs border border-slate-100 rounded">
              <thead className="bg-slate-50 text-slate-600 uppercase">
                <tr>
                  <th className="text-left px-3 py-2 font-semibold">Column Name</th>
                  <th className="text-center px-3 py-2 font-semibold">Required</th>
                  <th className="text-left px-3 py-2 font-semibold">Format</th>
                  <th className="text-left px-3 py-2 font-semibold">Example</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {COLUMNS.map((c) => (
                  <tr key={c.name} data-testid={`csv-col-${c.name}`}>
                    <td className="px-3 py-1.5 font-mono text-slate-800">{c.name}</td>
                    <td className="px-3 py-1.5 text-center">
                      {c.required ? <span className="text-emerald-600 font-bold">✓</span> : <span className="text-slate-300">—</span>}
                    </td>
                    <td className="px-3 py-1.5 text-slate-600">{c.format}</td>
                    <td className="px-3 py-1.5 font-mono text-slate-500">{c.example}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {onDownloadTemplate && (
            <button
              onClick={onDownloadTemplate}
              data-testid="csv-format-ref-download"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-teal-600 hover:bg-teal-700 text-white text-xs font-semibold rounded"
            >
              <Download className="w-3.5 h-3.5" /> Download Template
            </button>
          )}
        </div>
      )}
    </div>
  );
}
